/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { useMobileHeight } from './useMobileHeight.js';

const DSFullPageContainer = ({ children, ...props }) => {
  const height = useMobileHeight();
  return (
    <Grid height={height} width="100%" {...props}>
      {children}
    </Grid>
  );
};

export { DSFullPageContainer };
